import React from 'react';
import { useSelector } from 'react-redux';
import c from 'classnames';
import {
  Menu,
} from '@uncinc/react-drupal-core';
import { Button } from '@uncinc/uncinc-react-kitchen-sink';
import { DEFAULT_LANGUAGE } from '../../../config/constants';

import './style.scss';

const SECONDARY_DUTCH = 'secondary';
const SECONDARY_ENGLISH = 'en-secondary';

const SecondaryMenu = ({ buttonBlock = false }) => {
  const currentPage = useSelector((state) => state.getIn(['router', 'location', 'pathname'], ''));
  const currentLanguage = useSelector((state) => state.getIn(['ui', 'language']));
  let menuId = SECONDARY_DUTCH;
  // Load a specific menu on english language for the Main corporate site
  if (currentLanguage !== DEFAULT_LANGUAGE) menuId = SECONDARY_ENGLISH;

  return (
    <Menu id={menuId}>
      {(items) => {
        return (
          <>
            {items.map((item, index) => {
              if (item) {
                const title = item.getIn(['link', 'title'], 'Untitled');
                const url = item.getIn(['link', 'url'], '');
                const active = item.getIn(['link', 'url']) === currentPage;
                const isCta = index === 1;
                const SecondaryMenuItemClassnames = c('SecondaryMenu__item', {
                  'SecondaryMenu__item--active': active,
                });

                return (
                  <div key={title} className={SecondaryMenuItemClassnames}>
                    <Button
                      href={url}
                      className={`SecondaryMenu__item__link ${isCta && 'Button--cta'} ${buttonBlock && 'Button--block'}`}
                    >
                      <span className="SecondaryMenu__item__title">{title}</span>
                    </Button>
                  </div>
                );
              }
            })}
          </>
        );
      }}
    </Menu>
  );
};

export default SecondaryMenu;
